import forOwn from 'lodash/forOwn'

export const filterFavorites = (plants, favorites) => plants.filter(plant => !!favorites[plant.id])

export function filterPlants(plants, filters, favorites = []) {
    let filteredPlants = plants

    forOwn(filters, (active, name) => {
        if (active) {
            switch (name) {
                case 'favorites':
                    filteredPlants = filterFavorites(filteredPlants, favorites)
                    break
                default:
            }
        }
    })

    return filteredPlants
}



// WEBPACK FOOTER //
// ./src/components/utilities/helper/PlantHelper.js